module.exports = __webpack_public_path__ + "media/images/lb/749-8b780f1e4a49b933ab8e39f4e2639b07.svg";